module.exports = /[-\s]+(.)?/g


/*****************
 ** WEBPACK FOOTER
 ** ./~/ustring/src/hyphenRe.js
 ** module id = 828
 ** module chunks = 0
 **/